var map = {
	"./elem1-transperent-bcg.png": "4646",
	"./elem2-transperent-bcg.png": "e8eb",
	"./elem3-transperent-bcg.png": "62f4",
	"./elem4-transperent-bcg.png": "407d",
	"./elem5-transperent-bcg.png": "5859",
	"./elem6-transperent-bcg.png": "2f92"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc52";